import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import "../screens/User/Home/Home.css";
import PropTypes from "prop-types";
import "bootstrap/dist/css/bootstrap.css";
import pWa from "../images/download-review.png";

  const SecondSection = () => {
    return (
      <div className="container  mt-5">
        <h1
          className="text-center"
          style={{ color: "rgb(118, 102, 223)", fontSize: 50 }}
        >
          <i class="far fa-bookmark"></i> SERVICES
        </h1>

        <h5 className="text-center  mb-5">
          QUALITY SERVICES & USER EXPERIENCE
        </h5>

        <div class="row">
          <div class="col-lg-3 col-md-6 col-xs-12 pl-1 pr-1">
            <div class="card">
              <div style={{ display: "flex", justifyContent: "center" }}>
                <i class="fa fa-paint-brush fa-3x"></i>
              </div>
              <h3 className="mt-4">Web & Mobile App Design</h3>
              <p>
                Performing & High Usability Design and Interfaces. We should be
                on the path the a functional design so now for the exciting bit,
                beautiful, clean user interface.
              </p>
            </div>
          </div>
          <div class="col-lg-3 col-md-6 col-xs-12 pl-1 pr-1">
            <div class="card">
              <div style={{ display: "flex", justifyContent: "center" }}>
                <i class="fa fa-desktop fa-3x"></i>
              </div>
              <h3 className="mt-4">Web App Development</h3>
              <p>
                Every website should be built with two primary goals: Firstly,
                it needs to work across all devices. Secondly, it needs to be
                fast as possible.
              </p>
            </div>
          </div>
          <div class="col-lg-3 col-md-6 col-xs-12 pl-1 pr-1">
            <div class="card">
              <div style={{ display: "flex", justifyContent: "center" }}>
                <i class="fa fa-mobile fa-3x"></i>
              </div>
              <h3 className="mt-4">Mobile App Development</h3>
              <p>
                Develop unique and fully customized mobile applications for an
                optimal user experience that achieves your business goals.
              </p>
            </div>
          </div>

          <div class="col-lg-3 col-md-6 col-xs-12 pl-1 pr-1">
            <div class="card">
              <div style={{ display: "flex", justifyContent: "center" }}>
                <img src={pWa} style={{ height: 50, width: "8rem" }} />
              </div>
              <h3 className="mt-4">Progressive Web Apps</h3>
              <p>
                Progressive Web pages enable you to connect to the website, even
                when you are offline, PWA’s are not platform dependent and can
                run on any OS
              </p>
            </div>
          </div>
        </div>
      </div>
    );
  }
// }

SecondSection.propTypes = {
  fluid: PropTypes.bool,
  // applies .container-fluid className
};

export default withRouter(SecondSection);
